module.exports = __webpack_public_path__ + "static/media/target_lv_8f09c1a79d3fcd53554772f1c3b849e00.webp";